<template>
  <div>
    <HeaderComponent :isAdminPage="true" />
  </div>
  <div v-if="isInitError" id="com_form_contet_admin">
    <div class="errorform">
      <!-- エラーメッセージの表示エリア -->
      <div v-if="errorMessage" class="error-message">
        {{ errorMessage }}
      </div>
    </div>
  </div>
  <div v-else class="com_form_contet_admin">
    <section class="com_sec1">
      <div class="inner1">
        <h2 class="title_left">
          <template v-if="isEditModeUpdate">グローバルナビ編集</template>
          <template v-else>グローバルナビ登録</template>
        </h2>
      </div>
      <!-- エラーメッセージの表示エリア -->
      <div
        v-if="errorMessage"
        class="error-message"
        style="white-space: pre-wrap"
      >
        {{ errorMessage }}
      </div>
      <!-- グローバルナビ管理 -->
      <div class="form-group">
        <span>
          <label class="required-mark">※</label>
          設定名
          <input
            type="text"
            id="txtSettingName"
            class="text1 form-control"
            maxlength="255"
            v-model="glovalnaviKanriData.settingName"
            ref="txtSettingName"
          />
        </span>
        <span v-if="!isEditModeUpdate">
          <label class="required-mark">※</label>
          反映日
          <input
            type="date"
            id="reflectionDate"
            class="form-control"
            :max="AppConstants.MAX_DATE_VALUE"
            v-model="reflectionDate"
          />
        </span>
        <fieldset>
          <legend>設定対象</legend>
          <input
            type="radio"
            id="rdoDefault"
            name="targetSetting"
            class="form-check-input"
            value="0"
            v-model="glovalnaviKanriData.settingTargetKbn"
            v-bind:disabled="isDefaultId"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label1">デフォルト</label>
          <input
            type="radio"
            id="rdoAgsegment"
            name="targetSetting"
            class="form-check-input"
            value="1"
            v-model="glovalnaviKanriData.settingTargetKbn"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label2">エージェントセグメント</label>
          <select
            id="agSegmentList"
            class="select1 form-control"
            v-model="glovalnaviKanriData.settingTargetCode"
            v-bind:disabled="!isGlonaviTargetSegment"
          >
            <option></option>
            <option
              v-for="item in agSegmentList"
              :key="item.agSegmentCode"
              :value="item.agSegmentCode"
            >
              <div v-if="isGlonaviTargetSegment">
                {{ item.agSegmentCode }}：{{ item.agSegmentName }}
              </div>
            </option>
          </select>
          <input
            type="radio"
            id="rdoKobetuAg"
            name="targetSetting"
            class="form-check-input"
            value="2"
            v-model="glovalnaviKanriData.settingTargetKbn"
            v-on:change="onChangeSettingTarget"
          />
          <label class="label2">個別エージェント</label>
          <label class="label2">AGコード</label>
          <input
            v-if="isGlonaviTargetvCode"
            type="text"
            id="txtTitle"
            class="text2 form-control"
            maxlength="8"
            v-model="glovalnaviKanriData.settingTargetCode"
            v-bind:disabled="!isGlonaviTargetvCode"
          /><input
            v-else
            type="text"
            id="txtTitle"
            class="text2 form-control"
            maxlength="8"
            v-bind:disabled="!isGlonaviTargetvCode"
          />
        </fieldset>
      </div>
      <!-- グローバルナビ管理(現在設定) -->
      <div class="">
        <div class="tableLabel" v-if="isEditModeUpdate">
          <label class="label1">現在の設定</label>
          <label class="label3">反映日</label>
          <label class="label3">{{ reflectionDate }}</label>
          <label>管理ID：</label>
          <label>{{ glovalnaviKanriData.glonaviKanriId }}</label>
        </div>
        <table class="table table-bordered" id="nowSetting">
          <thead class="thead-light">
            <tr>
              <th class="col_selection">削除</th>
              <th class="col_catgory">カテゴリ</th>
              <th class="col_parentCategory">親カテゴリ</th>
              <th class="col_dispName">表示名</th>
              <th class="col_url">URL</th>
              <th class="col_link">リンク確認</th>
              <th class="col_dispTarget">表示順</th>
              <th class="col_separateTab">別タブ表示</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in glovalnaviKanriData.nowSettingList"
              :key="item.categoryId"
            >
              <td class="col_selection" data-name="mSelection">
                <input
                  id="mSelection"
                  type="checkbox"
                  class="form-check-input"
                  v-model="item.selection"
                />
              </td>
              <td>
                <select
                  id="table"
                  class="form-control"
                  v-model="item.categoryId"
                  @change="
                    changeUrl(
                      item.categoryId,
                      GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      index
                    )
                  "
                >
                  <option></option>
                  <option
                    v-for="item in categoryList"
                    :key="item.categoryId"
                    :value="item.categoryId"
                  >
                    {{ item.categoryName }}
                  </option>
                </select>
              </td>
              <td>
                <select
                  id="table"
                  class="form-control"
                  v-model="item.pairentId"
                >
                  <option></option>
                  <option
                    v-for="item in categoryList"
                    :key="item.categoryId"
                    :value="item.categoryId"
                  >
                    {{ item.categoryName }}
                  </option>
                </select>
              </td>
              <td class="unchanged">
                <input
                  style="
                    border: powderblue solid 1px;
                    text-align: left;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  id="dispName"
                  type="text"
                  maxlength="15"
                  v-model="item.dispName"
                />
              </td>
              <td class="unchanged" v-if="item.categoryId == sonotaCategoryId">
                <input
                  style="
                    border: powderblue solid 1px;
                    text-align: left;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  id="url"
                  type="text"
                  maxlength="255"
                  v-model="item.url"
                />
              </td>
              <td v-else style="text-align: left; padding-left: 12px">
                <label>
                  {{ item.url }}
                </label>
              </td>
              <td>
                <button
                  type="button"
                  name="mBtnUpdate"
                  class="btn btn-primary btn-sm"
                  v-bind:disabled="item.categoryId != sonotaCategoryId"
                  @click="
                    onLinkCheck(
                      GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      item.url,
                      index
                    )
                  "
                >
                  確認
                </button>
              </td>
              <td class="unchanged">
                <NumericInput
                  v-model="item.dispNo"
                  style="
                    border: powderblue solid 1px;
                    text-align: center;
                    padding-left: 8px;
                  "
                  class="form-control unchanged"
                  @input="
                    numberLimit(
                      GlonaviManegmentConstants.GLONAVI_SETTING_NOW,
                      index
                    )
                  "
                />
              </td>
              <td>
                <input
                  id="mSelection1"
                  type="checkbox"
                  class="form-check-input"
                  name="nowStting"
                  :value="0"
                  v-model="item.isSeparateTab"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div class="form-footer">
          <div class="form-group" style="text-align: right">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="rowAdd(GlonaviManegmentConstants.GLONAVI_SETTING_NOW)"
            >
              行追加
            </button>
          </div>
          <div
            class="form-group"
            style="text-align: center"
            v-if="isEditModeUpdate"
          >
            <button
              type="button"
              name="btnBack"
              class="btn addbtn btn-primary"
              @click="onCopy"
            >
              下にコピーする▼
            </button>
          </div>
        </div>

        <!-- グローバルナビ管理(反映予定) -->
        <div class="" v-if="isEditModeUpdate">
          <hr />
          <div class="tableLabel">
            <label class="label1">反映予定の設定</label>
            <label class="label2">反映日</label>
            <input
              type="date"
              id="txtDispDtFrom"
              class="inputDate form-control"
              v-model="scheduledDate"
              :max="AppConstants.MAX_DATE_VALUE"
            />
            <label>管理ID：</label>
            <label>{{ glovalnaviKanriData.glonaviKanriId }}</label>
          </div>
          <table class="table table-bordered" v-if="isDataFetched">
            <thead class="thead-light">
              <tr>
                <th class="col_selection">削除</th>
                <th class="col_catgory">カテゴリ</th>
                <th class="col_parentCategory">親カテゴリ</th>
                <th class="col_dispName">表示名</th>
                <th class="col_url">URL</th>
                <th class="col_link">リンク確認</th>
                <th class="col_dispTarget">表示順</th>
                <th class="col_separateTab">別タブ表示</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in glovalnaviKanriData.scheduleSettingList"
                :key="item.categoryId"
              >
                <td class="col_selection" data-name="mSelection">
                  <input
                    id="mSelection"
                    type="checkbox"
                    class="form-check-input"
                    v-model="item.selection"
                  />
                </td>
                <td>
                  <select
                    id="table"
                    class="form-control"
                    v-model="item.categoryId"
                    @change="
                      changeUrl(
                        item.categoryId,
                        GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        index
                      )
                    "
                  >
                    <option></option>
                    <option
                      v-for="item in categoryList"
                      :key="item.categoryId"
                      :value="item.categoryId"
                    >
                      {{ item.categoryName }}
                    </option>
                  </select>
                </td>
                <td>
                  <select
                    id="table"
                    class="form-control"
                    v-model="item.pairentId"
                  >
                    <option></option>
                    <option
                      v-for="item in categoryList"
                      :key="item.categoryId"
                      :value="item.categoryId"
                    >
                      {{ item.categoryName }}
                    </option>
                  </select>
                </td>
                <td class="unchanged">
                  <input
                    style="
                      border: powderblue solid 1px;
                      text-align: left;
                      padding-left: 8px;
                    "
                    class="form-control unchanged"
                    id="dispName"
                    type="text"
                    maxlength="15"
                    v-model="item.dispName"
                  />
                </td>
                <td
                  class="unchanged"
                  v-if="item.categoryId == sonotaCategoryId"
                >
                  <input
                    style="
                      border: powderblue solid 1px;
                      text-align: left;
                      padding-left: 8px;
                    "
                    class="form-control unchanged"
                    id="url"
                    type="text"
                    maxlength="255"
                    v-model="item.url"
                  />
                </td>
                <td v-else style="text-align: left; padding-left: 12px">
                  <label>
                    {{ item.url }}
                  </label>
                </td>
                <td>
                  <button
                    type="button"
                    name="mBtnUpdate"
                    class="btn btn-primary btn-sm"
                    v-bind:disabled="item.categoryId != sonotaCategoryId"
                    @click="
                      onLinkCheck(
                        GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        item.url,
                        index
                      )
                    "
                  >
                    確認
                  </button>
                </td>
                <td class="unchanged">
                  <NumericInput
                    v-model="item.dispNo"
                    style="
                      border: powderblue solid 1px;
                      text-align: center;
                      padding-left: 8px;
                    "
                    class="form-control unchanged"
                    @input="
                      numberLimit(
                        GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE,
                        index
                      )
                    "
                  />
                </td>
                <td>
                  <input
                    id="mSelection2"
                    type="checkbox"
                    class="form-check-input"
                    name="scheduledSetting"
                    :value="1"
                    v-model="item.isSeparateTab"
                  />
                </td>
              </tr>
            </tbody>
          </table>
          <div class="form-group" style="text-align: right">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="
                rowAdd(GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE)
              "
            >
              行追加
            </button>
          </div>
          <label
            >※リンクの確認およびプレビューは、入力後、確定をしないと反映されません。</label
          >
        </div>
        <div class="form-inline flex-container">
          <div class="form-group">
            <button
              type="button"
              name="btnDelete"
              class="btn btn-footer btn-primary"
              @click="onDelete"
            >
              行削除
            </button>
          </div>

          <div class="form-group" v-if="isEditModeUpdate">
            <button
              type="button"
              name="btnDelete"
              class="btn previewbtn btn-primary"
              @click="onPreview(GlonaviManegmentConstants.GLONAVI_SETTING_NOW)"
            >
              現在の設定をプレビュー
            </button>
            <button
              type="button"
              name="btnDelete"
              class="btn previewbtn btn-primary"
              @click="
                onPreview(GlonaviManegmentConstants.GLONAVI_SETTING_SCHEDULE)
              "
            >
              反映予定の設定をプレビュー
            </button>
          </div>

          <div class="form-group">
            <button
              type="button"
              name="btnBack"
              class="btn btn-footer btn-primary"
              @click="goBack"
            >
              戻る
            </button>
            <button
              type="button"
              name="btnClear"
              class="btn btn-footer btn-primary"
              v-if="!isEditModeUpdate"
              @click="onClear"
            >
              クリア
            </button>
            <button
              type="button"
              name="btnAdd"
              class="btn btn-footer btn-primary"
              @click="onFixed"
            >
              確定
            </button>
          </div>
        </div>
      </div>
    </section>
  </div>
  <div>
    <!-- フッタ -->
    <FooterComponent />
  </div>
  <BackToTop />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed, PropType } from "vue";
import HeaderComponent from "../layout/HeaderComponent.vue";
import FooterComponent from "../layout/FooterComponent.vue";
import {
  formatMessage,
  sanitizeInput,
  scrollToTop,
  isTokenAlive,
  commonHandleAxiosError,
  hasNoGaiji,
  outputDebugLogs,
} from "@/Common";
import { format } from "date-fns";
import { AppConstants } from "@/constants/AppConstants";
import apiAuthClient from "@/util/apiClientAuth";
import { useProcessingStore } from "../../store/useProcessingStore";
import messages from "@/assets/messages.json";
import BackToTop from "../controls/BackToTop.vue";
import { useUserStore } from "@/store/userStore";
import { useRouter, useRoute } from "vue-router";
import { goBackToPreviousUrl } from "@/router";
import NumericInput from "../controls/NumericInput.vue";

interface NowList {
  selection: boolean;
  reflectionDate: string;
  kanriId: string;
  pairentId: string;
  categoryId: string;
  dispName: string;
  url: string;
  dispNo: number;
  isSeparateTab: boolean;
}

interface scheduleList {
  selection: boolean;
  reflectionDate: string;
  kanriId: string;
  pairentId: string;
  categoryId: string;
  dispName: string;
  url: string;
  dispNo: number;
  isSeparateTab: boolean;
}

interface GlovalnaviKanriData {
  glonaviKanriId: string;
  settingName: string;
  settingTargetKbn: string;
  settingTargetName: string;
  settingTargetCode: string;
  nowSettingList: NowList[];
  scheduleSettingList: scheduleList[];
}

interface Category {
  categoryId: string;
  categoryName: string;
  categoryUrl: string;
}

interface AgSegment {
  agSegmentCode: string;
  agSegmentName: string;
}

interface InitialDisplayData {
  categoryList: Category[];
  agSegmentList: AgSegment[];
  defaultKanriId: string;
  reflectionDate: string;
  sonotaCategoryId: string;
}

class GlonaviManegmentConstants {
  // 設定
  static readonly GLONAVI_SETTING_NOW = "01"; // 現在設定
  static readonly GLONAVI_SETTING_SCHEDULE = "02"; // 反映予定
}

export default defineComponent({
  name: "GlobalNaviManegmentComponent",
  components: {
    HeaderComponent,
    FooterComponent,
    BackToTop,
    NumericInput,
  },
  props: {
    glovalNaviKanriId: {
      type: String as PropType<string>,
    },
    editMode: {
      type: String as PropType<string>,
    },
  },
  setup() {
    const isInitError = ref(true); // 初期表示時のエラーフラグ
    const processingStore = useProcessingStore();
    const router = useRouter();
    const route = useRoute();
    const isDataFetched = ref(false); // データが取得済みかどうかを追跡
    const errorMessage = ref(""); // エラーメッセージ（キーワード検索の下のやつ）
    const isKaunetAdmin = ref(false); // カウネット管理者フラグ
    const paramGlonvalNaviKanriId = computed(
      () => route.query.glovalNaviKanriId as string
    ); // パラメータ．グローバルナビ管理ID
    const paramEditMode = computed(() => route.query.editMode as string); // パラメータ．編集モード
    const agCode = ref(""); // ローカルストレージ．AGコード
    const userId = ref(""); // ローカルストレージ．ユーザーID
    const categoryList = ref<Category[]>([]); // カテゴリリスト
    const agSegmentList = ref<AgSegment[]>([]); // AGセグメントリスト
    const isDefaultId = ref(false); // デフォルト設定済みかどうか
    const defaultKanriId = ref(""); // デフォルトグローバルナビ管理ID
    const reflectionDate = ref(""); // 反映日
    const scheduledDate = ref(""); // 反映予定日
    const sonotaCategoryId = ref(""); //その他のカテゴリID
    const { logoutUser } = useUserStore();
    const glovalnaviKanriData = ref<GlovalnaviKanriData>({
      glonaviKanriId: "",
      settingName: "",
      settingTargetKbn: "",
      settingTargetName: "",
      settingTargetCode: "",
      nowSettingList: [],
      scheduleSettingList: [],
    });

    const beforeGlonaviData = ref<GlovalnaviKanriData>({
      glonaviKanriId: "",
      settingName: "",
      settingTargetKbn: "",
      settingTargetName: "",
      settingTargetCode: "",
      nowSettingList: [],
      scheduleSettingList: [],
    });

    const initialDisplayData = ref<InitialDisplayData>({
      categoryList: [],
      agSegmentList: [],
      defaultKanriId: "",
      reflectionDate: "",
      sonotaCategoryId: "",
    });

    // routerパラメータ退避用
    let glovalNaviKanriId = ref(""); // グローバルナビ管理ID
    let editMode = ref(""); // 編集モード

    const txtSettingName = ref<HTMLInputElement | null>(null);

    // 初期処理
    onMounted(async () => {
      // ローカルストレージからユーザー情報を取得して内部変数に展開
      const userInfo = localStorage.getItem(AppConstants.USER_SESSION_NAME);
      if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        agCode.value = parsedUserInfo.agCode;
        userId.value = parsedUserInfo.userId;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        // 初期処理時はTrue
        isInitError.value = true;

        // パラメーターから取得
        glovalNaviKanriId.value = paramGlonvalNaviKanriId.value;
        editMode.value = paramEditMode.value;

        // 初期表示データ取得
        const response = await apiAuthClient.post(
          "/api/GlovalNaviManegment/GetInitialDisplayData",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
          }
        );

        initialDisplayData.value = response.data.glovalNaviInitialDisplayData;

        // カテゴリリストコンボボックス設定
        categoryList.value = initialDisplayData.value.categoryList;

        // エージェントセグメントコンボボックス設定
        agSegmentList.value = initialDisplayData.value.agSegmentList;

        defaultKanriId.value = initialDisplayData.value.defaultKanriId;

        sonotaCategoryId.value = initialDisplayData.value.sonotaCategoryId;

        // 反映日設定
        reflectionDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );
        scheduledDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );

        // 編集モードが更新の場合
        if (isEditModeUpdate.value) {
          await getGlovalNaviData();

          if (defaultKanriId.value !== glovalNaviKanriId.value) {
            // デフォルト設定ではないなら
            isDefaultId.value = true;
          }
        } else {
          if (defaultKanriId.value != "") {
            // デフォルトの管理IDが設定されているなら
            isDefaultId.value = true;
            glovalnaviKanriData.value.settingTargetKbn = "1";
          } else {
            glovalnaviKanriData.value.settingTargetKbn = "0";
          }
        }

        setTimeout(function () {
          // フォーカス設定
          if (txtSettingName.value) {
            txtSettingName.value.focus();
          }
        }, 1);

        isInitError.value = false;
        isDataFetched.value = true; // データが取得されたことを設定
      } catch (error: unknown) {
        // エラー時は初期表示エラーフラグをON
        isInitError.value = true;
        // エラー処理
        handleAxiosError(error);
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    });

    /**
     * グローバルナビ管理データ取得
     */
    const getGlovalNaviData = async (): Promise<boolean> => {
      try {
        const response = await apiAuthClient.post(
          "/api/GlovalNaviManegment/GetGlovalNaviData",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            glonaviKanriId: glovalNaviKanriId.value,
          }
        );

        // レスポンスを保持
        glovalnaviKanriData.value = response.data.gloValNaviKanriData;

        // データがゼロ件の場合は一覧画面へ遷移する
        if (!glovalnaviKanriData.value.glonaviKanriId) {
          router.push("/glovalnavi-kanri-list");
          return false;
        }

        // 反映日設定
        reflectionDate.value =
          glovalnaviKanriData.value.nowSettingList[0].reflectionDate;

        // 反映予定日設定
        if (
          Object.keys(glovalnaviKanriData.value.scheduleSettingList).length > 0
        ) {
          scheduledDate.value = formatDate(
            glovalnaviKanriData.value.scheduleSettingList[0].reflectionDate
          );
        }

        // 変更前のリストを退避
        beforeGlonaviData.value = JSON.parse(
          JSON.stringify(glovalnaviKanriData.value)
        );

        scrollToTop();

        return true;
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        return false;
      }
    };

    /**
     * 登録ボタン押下
     */
    const onFixed = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      // メッセージクリア
      errorMessage.value = "";

      // 入力チェック
      if (!validateInput()) {
        scrollToTop();
        return;
      }

      // トークン有効性チェック
      if ((await isTokenAlive()) == false) {
        // トークンが無効な場合はログイン画面へ
        logoutUser();
        alert(messages.ERR_USER001);
        router.push("/login");
        return;
      }

      // 確認ダイアログ表示
      const isConfirm = window.confirm(
        formatMessage(
          messages.CNF_0001,
          "データ",
          isEditModeUpdate.value ? "更新" : "登録"
        )
      );
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // 処理中フラグON
      processingStore.isProcessing = true;

      try {
        if (isEditModeUpdate.value) {
          // 更新処理
          await executeUpdate();
        } else {
          // 登録処理
          await executeCreate();
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 登録処理
     */
    const executeCreate = async () => {
      try {
        // 表示順で並び替え
        glovalnaviKanriData.value.nowSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );

        // グローバルナビ管理データ登録APIを実行
        const response = await apiAuthClient.post(
          "/api/GlovalNaviManegment/regGlobalNavi",
          {
            systemKbn: AppConstants.SYSTEM_KBN_WITH,
            agCode: agCode.value,
            userId: userId.value,
            settingName: sanitizeInput(glovalnaviKanriData.value.settingName),
            settingTargetKbn: glovalnaviKanriData.value.settingTargetKbn,
            settingTargetName: glovalnaviKanriData.value.settingTargetName,
            settingTargetCode: glovalnaviKanriData.value.settingTargetCode,
            nowSettingList: glovalnaviKanriData.value.nowSettingList.map(
              (glonaviData) => ({
                selection: glonaviData.selection,
                reflectionDate: glonaviData.reflectionDate,
                kanriId: glonaviData.kanriId,
                pairentId: glonaviData.pairentId,
                categoryId: glonaviData.categoryId,
                dispName: sanitizeInput(glonaviData.dispName),
                url: sanitizeInput(glonaviData.url),
                dispNo: glonaviData.dispNo,
                isSeparateTab: glonaviData.isSeparateTab,
              })
            ),
          }
        );
        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "登録"));

        // もとの画面に戻る処理
        goBackToPreviousUrl();
        // // 確認ダイアログ表示
        // const isConfirm = window.confirm(formatMessage(messages.CNF_0005));
        // if (isConfirm) {
        //   // OKの場合

        //   // 新規登録可能な状態にする
        //   resetNew();
        // } else {
        //   // キャンセルの場合

        //   // 編集モードを設定
        //   editMode.value = AppConstants.CONTENTS_EDIT_MODE_UPDATE;
        //   // コンテンツIDを設定
        //   glovalNaviKanriId.value = response.data.glovalNaviKanriId;

        //   // コンテンツデータ再取得
        //   await getGlovalNaviData();

        //   setTimeout(function () {
        //     // フォーカス設定
        //     if (txtSettingName.value) {
        //       txtSettingName.value.focus();
        //     }
        //   }, 1);
        // }
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /**
     * 新規登録可能な状態にする
     */
    const resetNew = () => {
      // 新規登録モードを設定
      editMode.value = AppConstants.CONTENTS_EDIT_MODE_NEW;
      // 画面入力内容クリア
      glovalnaviKanriData.value = getGlovalnaviKanriDataDef();

      //反映日初期値設定
      reflectionDate.value = formatDate(
        initialDisplayData.value.reflectionDate
      );

      // スクロールを上部に移動
      scrollToTop();

      setTimeout(function () {
        // フォーカス設定
        if (txtSettingName.value) {
          txtSettingName.value.focus();
        }
      }, 1);
    };

    /**
     * 更新処理
     */
    const executeUpdate = async () => {
      try {
        // 反映予定日セット
        Object.values(glovalnaviKanriData.value.scheduleSettingList).forEach(
          (item) => {
            if (item && typeof item.reflectionDate === "string") {
              item.reflectionDate = scheduledDate.value.toString();
            }
          }
        );

        // 表示順で並び替え
        glovalnaviKanriData.value.nowSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );
        glovalnaviKanriData.value.scheduleSettingList.sort(
          (a, b) => a.dispNo - b.dispNo
        );

        // グローバルナビ管理更新APIを実行
        await apiAuthClient.post("/api/GlovalNaviManegment/updateGlobalNavi", {
          systemKbn: AppConstants.SYSTEM_KBN_WITH,
          agCode: agCode.value,
          userId: userId.value,
          glonaviKanriId: glovalNaviKanriId.value,
          settingName: sanitizeInput(glovalnaviKanriData.value.settingName),
          settingTargetKbn: glovalnaviKanriData.value.settingTargetKbn,
          settingTargetName: glovalnaviKanriData.value.settingTargetName,
          settingTargetCode: glovalnaviKanriData.value.settingTargetCode,
          nowSettingList: glovalnaviKanriData.value.nowSettingList.map(
            (glonaviData) => ({
              selection: glonaviData.selection,
              reflectionDate: glonaviData.reflectionDate,
              kanriId: glonaviData.kanriId,
              pairentId: glonaviData.pairentId,
              categoryId: glonaviData.categoryId,
              dispName: sanitizeInput(glonaviData.dispName),
              url: sanitizeInput(glonaviData.url),
              dispNo: glonaviData.dispNo,
              isSeparateTab: glonaviData.isSeparateTab,
            })
          ),
          scheduleSettingList:
            glovalnaviKanriData.value.scheduleSettingList.map(
              (glonaviData) => ({
                selection: glonaviData.selection,
                reflectionDate: glonaviData.reflectionDate,
                kanriId: glonaviData.kanriId,
                pairentId: glonaviData.pairentId,
                categoryId: glonaviData.categoryId,
                dispName: sanitizeInput(glonaviData.dispName),
                url: sanitizeInput(glonaviData.url),
                dispNo: glonaviData.dispNo,
                isSeparateTab: glonaviData.isSeparateTab,
              })
            ),
        });

        // 完了メッセージ表示
        alert(formatMessage(messages.INF_0001, "データ", "更新"));

        // コンテンツデータ再取得
        await getGlovalNaviData();
      } catch (error: unknown) {
        // エラー処理
        handleAxiosError(error);
        scrollToTop();
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** リンク確認ボタン押下時 */
    const onLinkCheck = (listype: string, url: string, index: number) => {
      if (listype == GlonaviManegmentConstants.GLONAVI_SETTING_NOW) {
        if (
          beforeGlonaviData.value.nowSettingList[index] &&
          glovalnaviKanriData.value.nowSettingList[index].url ==
            beforeGlonaviData.value.nowSettingList[index].url
        ) {
          window.open(url);
        } else {
          errorMessage.value = messages.ERR_0033;
          scrollToTop();
        }
      } else {
        if (
          beforeGlonaviData.value.scheduleSettingList[index] &&
          glovalnaviKanriData.value.scheduleSettingList[index].url ==
            beforeGlonaviData.value.scheduleSettingList[index].url
        ) {
          window.open(url);
        } else {
          errorMessage.value = messages.ERR_0033;
          scrollToTop();
        }
      }
    };

    /** 下にコピーするボタン押下時 */
    const onCopy = () => {
      if (glovalnaviKanriData.value.scheduleSettingList.length > 0) {
        // 確認ダイアログ表示
        const isConfirm = window.confirm(
          formatMessage(messages.CNF_0001, "現在設定のデータ", "下にコピー")
        );
        if (!isConfirm) {
          // いいえの場合
          return;
        }
      }

      // 現在設定を反映予定データにコピー
      var copyList = JSON.parse(
        JSON.stringify(glovalnaviKanriData.value.nowSettingList)
      );

      glovalnaviKanriData.value.scheduleSettingList = copyList;
    };

    /** 行追加ボタン押下時 */
    const rowAdd = (listType: string) => {
      if (listType == GlonaviManegmentConstants.GLONAVI_SETTING_NOW) {
        glovalnaviKanriData.value.nowSettingList.push({
          selection: false,
          reflectionDate: reflectionDate.value,
          kanriId: "",
          pairentId: "",
          categoryId: "",
          dispName: "",
          url: "",
          dispNo: 0,
          isSeparateTab: false,
        });
      } else {
        glovalnaviKanriData.value.scheduleSettingList.push({
          selection: false,
          reflectionDate: scheduledDate.value,
          kanriId: "",
          pairentId: "",
          categoryId: "",
          dispName: "",
          url: "",
          dispNo: 0,
          isSeparateTab: false,
        });
      }
    };

    /** 削除ボタン押下時 */
    const onDelete = () => {
      glovalnaviKanriData.value.nowSettingList =
        glovalnaviKanriData.value.nowSettingList.filter(
          (item) => item.selection == false
        );
      glovalnaviKanriData.value.scheduleSettingList =
        glovalnaviKanriData.value.scheduleSettingList.filter(
          (item) => item.selection == false
        );
    };

    /**
     * プレビュー表示
     */
    const onPreview = (detailKbn: string) => {
      const routeData = router.resolve({
        name: "PreviewGlobalNavi",
        params: {
          glovalNaviKanriId: glovalnaviKanriData.value.glonaviKanriId,
          detailKbn: detailKbn,
        },
      });

      // 別タブで表示する
      window.open(routeData.href, "_blank_");
    };

    /**
     * クリアボタン押下時
     */
    const onClear = async () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }
      // 処理中フラグON
      processingStore.isProcessing = true;

      // メッセージクリア
      errorMessage.value = "";

      try {
        // トークン有効性チェック
        if ((await isTokenAlive()) == false) {
          // トークンが無効な場合はログイン画面へ
          logoutUser();
          alert(messages.ERR_USER001);
          router.push("/login");
          return;
        }

        // 初期化
        glovalnaviKanriData.value = getGlovalnaviKanriDataDef();

        // 反映日初期値設定
        reflectionDate.value = formatDate(
          initialDisplayData.value.reflectionDate
        );

        outputDebugLogs("defaultKanriId.value:" + defaultKanriId.value);

        // 表示対象初期値設定
        if (defaultKanriId.value != "") {
          isDefaultId.value = true;
          glovalnaviKanriData.value.settingTargetKbn = "1";
        } else {
          glovalnaviKanriData.value.settingTargetKbn = "0";
        }
      } finally {
        // 処理中フラグOFF
        processingStore.isProcessing = false;
      }
    };

    /** 戻るボタン押下時 */
    const goBack = () => {
      if (processingStore.isProcessing) {
        // 何か処理中なら処理をしない
        return;
      }

      const isConfirm = window.confirm(formatMessage(messages.CNF_0002));
      if (!isConfirm) {
        // いいえの場合
        return;
      }

      // もとの画面に戻る処理
      goBackToPreviousUrl();
    };

    /**
     * 入力チェック
     */
    const validateInput = (): boolean => {
      const messageList = ref<string[]>([]);

      // 設定名
      // 必須チェック、使用不可文字チェック
      const sanitizedSettingName = sanitizeInput(
        glovalnaviKanriData.value.settingName
      );
      if (!sanitizedSettingName) {
        messageList.value.push(formatMessage(messages.ERR_0001, "設定名"));
      } else if (!hasNoGaiji(sanitizedSettingName)) {
        messageList.value.push(formatMessage(messages.ERR_0026, "設定名"));
      }

      // 反映日（現在設定）
      // 必須チェック
      if (!reflectionDate.value) {
        messageList.value.push(formatMessage(messages.ERR_0001, "反映日"));
      }

      // 反映日 (反映予定)
      // 反映予定が入力済みで、編集モードの場合
      if (
        glovalnaviKanriData.value.scheduleSettingList.length > 0 &&
        isEditModeUpdate.value
      ) {
        // 反映日 (反映予定)
        // 必須チェック
        if (!scheduledDate.value) {
          messageList.value.push(
            formatMessage(messages.ERR_0001, "［反映予定の設定］反映日")
          );
        }

        // 反映日 (反映予定)
        // 反映日と現在設定の反映日大小チェック
        if (new Date(reflectionDate.value) > new Date(scheduledDate.value)) {
          messageList.value.push(formatMessage(messages.ERR_0034));
        }
      }

      if (isGlonaviTargetSegment.value) {
        // エージェントセグメント

        // 必須チェック
        if (!glovalnaviKanriData.value.settingTargetCode) {
          messageList.value.push(
            formatMessage(messages.ERR_0003, "エージェントセグメント")
          );
        }
      } else if (isGlonaviTargetvCode.value) {
        // AGコード

        const sanitizedAgCode = sanitizeInput(
          glovalnaviKanriData.value.settingTargetCode
        );
        // 必須チェック、使用不可文字チェック
        if (!sanitizedAgCode) {
          messageList.value.push(formatMessage(messages.ERR_0002, "AGコード"));
        } else if (!hasNoGaiji(sanitizedAgCode)) {
          messageList.value.push(formatMessage(messages.ERR_0026, "AGコード"));
        }
      }

      // 現在設定明細チェック
      if (glovalnaviKanriData.value.nowSettingList.length == 0) {
        messageList.value.push(formatMessage(messages.ERR_0004, "現在の設定"));
      }

      // 現在設定チェック
      for (var data1 in glovalnaviKanriData.value.nowSettingList) {
        // カテゴリ
        // 必須チェック
        if (!glovalnaviKanriData.value.nowSettingList[data1].categoryId) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value ? "［現在の設定］カテゴリ" : "カテゴリ"
            )
          );
        } else {
          // 親カテゴリとカテゴリ同一チェック
          if (
            glovalnaviKanriData.value.nowSettingList[data1].categoryId ==
            glovalnaviKanriData.value.nowSettingList[data1].pairentId
          ) {
            messageList.value.push(formatMessage(messages.ERR_0032));
          }
        }

        // 表示名
        // 必須チェック、使用不可文字チェック
        const sanitizedDispName = sanitizeInput(
          glovalnaviKanriData.value.nowSettingList[data1].dispName
        );
        if (!sanitizedDispName) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［現在の設定］表示名" : "表示名"
            )
          );
        } else if (!hasNoGaiji(sanitizedDispName)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value ? "［現在の設定］表示名" : "表示名"
            )
          );
        }

        // URL
        // 必須チェック、使用不可文字チェック
        const sanitizedUrl = sanitizeInput(
          glovalnaviKanriData.value.nowSettingList[data1].url
        );
        if (!sanitizedUrl) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［現在の設定］URL" : "URL"
            )
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value ? "［現在の設定］URL" : "URL"
            )
          );
        }

        // 表示順
        // 必須チェック
        if (!glovalnaviKanriData.value.nowSettingList[data1].dispNo) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［現在の設定］表示順" : "表示順"
            )
          );
        }
      }

      // 反映予定チェック
      for (var data2 in glovalnaviKanriData.value.scheduleSettingList) {
        // カテゴリ
        // 必須チェック
        if (!glovalnaviKanriData.value.scheduleSettingList[data2].categoryId) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0003,
              isEditModeUpdate.value ? "［反映予定の設定］カテゴリ" : "カテゴリ"
            )
          );
        } else {
          // 親カテゴリとカテゴリ同一チェック
          if (
            glovalnaviKanriData.value.scheduleSettingList[data2].categoryId ==
            glovalnaviKanriData.value.scheduleSettingList[data2].pairentId
          ) {
            messageList.value.push(formatMessage(messages.ERR_0032));
          }
        }

        // 表示名
        // 必須チェック、使用不可文字チェック
        const sanitizedDispName = sanitizeInput(
          glovalnaviKanriData.value.scheduleSettingList[data2].dispName
        );
        if (!sanitizedDispName) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［反映予定の設定］表示名" : "表示名"
            )
          );
        } else if (!hasNoGaiji(sanitizedDispName)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value ? "［反映予定の設定］表示名" : "表示名"
            )
          );
        }

        // URL
        // 必須チェック、使用不可文字チェック
        const sanitizedUrl = sanitizeInput(
          glovalnaviKanriData.value.scheduleSettingList[data2].url
        );
        if (!sanitizedUrl) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［反映予定の設定］URL" : "URL"
            )
          );
        } else if (!hasNoGaiji(sanitizedUrl)) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0026,
              isEditModeUpdate.value ? "［反映予定の設定］URL" : "URL"
            )
          );
        }

        // 表示順
        // 必須チェック
        if (!glovalnaviKanriData.value.scheduleSettingList[data2].dispNo) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0001,
              isEditModeUpdate.value ? "［反映予定の設定］表示順" : "表示順"
            )
          );
        }
      }

      // 表示順(現在設定)
      // 重複チェック
      const setNo1 = new Set();
      glovalnaviKanriData.value.nowSettingList.forEach((item) => {
        if (setNo1.has(item.dispNo.toString())) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0017,
              isEditModeUpdate.value ? "［現在の設定］表示順" : "表示順"
            )
          );
        }
        setNo1.add(item.dispNo.toString());
      });

      // 表示順(反映予定)
      // 重複チェック
      const setNo2 = new Set();
      glovalnaviKanriData.value.scheduleSettingList.forEach((item) => {
        if (setNo2.has(item.dispNo.toString())) {
          messageList.value.push(
            formatMessage(
              messages.ERR_0017,
              isEditModeUpdate.value ? "［反映予定の設定］表示順" : "表示順"
            )
          );
        }
        setNo2.add(item.dispNo.toString());
      });

      // エラーがある場合
      if (messageList.value.length > 0) {
        messageList.value.forEach((message, index) => {
          if (index > 0) {
            errorMessage.value += String.fromCharCode(10);
          }
          errorMessage.value += message;
        });
        return false;
      } else {
        errorMessage.value = "";
        return true;
      }
    };

    /**
     * 編集モードUPDATE判定
     */
    const isEditModeUpdate = computed(() => {
      return editMode.value == AppConstants.CONTENTS_EDIT_MODE_UPDATE;
    });

    /**
     * AG_SEGMENT判定
     */
    const isGlonaviTargetSegment = computed(() => {
      return glovalnaviKanriData.value.settingTargetKbn == "1";
    });

    /**
     * AG_SEGMENT_CODE判定
     */
    const isGlonaviTargetvCode = computed(() => {
      return glovalnaviKanriData.value.settingTargetKbn == "2";
    });

    /**
     * 表示対象ラジオ変更時
     */
    const onChangeSettingTarget = () => {
      glovalnaviKanriData.value.settingTargetCode = "";
      glovalnaviKanriData.value.settingTargetName = "";
    };

    /**
     * カテゴリリストＵＲＬ連動
     */
    const changeUrl = (categoryId: string, listType: string, index: number) => {
      const resultUrl = categoryList.value.find(
        (category) => category.categoryId == categoryId
      );

      if (resultUrl !== undefined) {
        if (listType == GlonaviManegmentConstants.GLONAVI_SETTING_NOW) {
          glovalnaviKanriData.value.nowSettingList[index].url =
            resultUrl.categoryUrl;
        } else {
          glovalnaviKanriData.value.scheduleSettingList[index].url =
            resultUrl.categoryUrl;
        }
      }
    };

    /**
     * サーバー日付をフォーマットします。
     */
    const formatDate = (strDate: string): string => {
      if (strDate) {
        return format(strDate, "yyyy-MM-dd");
      }
      return "";
    };

    /**
     * AxiosErrorを処理します。
     * @param error エラー情報
     */
    const handleAxiosError = (error: unknown) => {
      errorMessage.value = commonHandleAxiosError(error, true);
    };

    /**
     * コンテンツデータの初期値を返却します。
     */
    const getGlovalnaviKanriDataDef = (): GlovalnaviKanriData => {
      return {
        glonaviKanriId: "",
        settingName: "",
        settingTargetKbn: "",
        settingTargetName: "",
        settingTargetCode: "",
        nowSettingList: [],
        scheduleSettingList: [],
      };
    };

    // 表示順桁数制限
    const numberLimit = (listType: string, index: number) => {
      const maxlength = 3;
      if (listType == GlonaviManegmentConstants.GLONAVI_SETTING_NOW) {
        if (
          glovalnaviKanriData.value.nowSettingList[index].dispNo &&
          glovalnaviKanriData.value.nowSettingList[index].dispNo.toString()
            .length > maxlength
        ) {
          glovalnaviKanriData.value.nowSettingList[index].dispNo = parseInt(
            glovalnaviKanriData.value.nowSettingList[index].dispNo
              .toString()
              .slice(0, maxlength)
          );
        }
      } else {
        if (
          glovalnaviKanriData.value.scheduleSettingList[index].dispNo &&
          glovalnaviKanriData.value.scheduleSettingList[index].dispNo.toString()
            .length > maxlength
        ) {
          glovalnaviKanriData.value.scheduleSettingList[index].dispNo =
            parseInt(
              glovalnaviKanriData.value.scheduleSettingList[index].dispNo
                .toString()
                .slice(0, maxlength)
            );
        }
      }
    };

    return {
      isInitError,
      isDataFetched,
      errorMessage,
      isKaunetAdmin,
      isEditModeUpdate,
      isGlonaviTargetSegment,
      isGlonaviTargetvCode,
      isDefaultId,
      goBack,
      onLinkCheck,
      onCopy,
      rowAdd,
      onDelete,
      onClear,
      onFixed,
      changeUrl,
      glovalnaviKanriData,
      beforeGlonaviData,
      initialDisplayData,
      categoryList,
      agSegmentList,
      defaultKanriId,
      reflectionDate,
      scheduledDate,
      AppConstants,
      onChangeSettingTarget,
      txtSettingName,
      onPreview,
      GlonaviManegmentConstants,
      numberLimit,
      sonotaCategoryId,
    };
  },
});
</script>
<style scoped>
td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 0;
}
.col_selection {
  width: 4%;
}
.col_catgory {
  width: 15%;
}
.col_parentCategory {
  width: 15%;
}
.col_dispName {
  width: 16%;
}
.col_url {
  width: 26%;
}
.col_link {
  width: 8%;
}
.col_dispTarget {
  width: 8%;
}
.col_separateTab {
  width: 8%;
}
fieldset {
  border: 2px solid #ccc;
  padding: 10px;
  margin: 10px 0;
}
legend {
  font-weight: bold;
  padding: 0 10px;
  float: initial;
  width: initial;
  margin-bottom: initial;
  font-size: initial;
  line-height: initial;
}
.form-control-title {
  text-align: center;
  background-color: lightgrey;
  border-radius: 0.25rem;
}
.changed {
  background-color: #bed0f3;
}
.errorform {
  margin-top: 50px;
  width: 100%;
  height: 500px;
  text-align: center;
}
.flex-container {
  display: flex;
  justify-content: space-between;
}
.btn {
  margin: 0.25rem 0.125rem;
}
.btn-footer {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  width: 140px;
}
.addbtn {
  margin: 0.5rem 0.55rem;
  border-radius: 1rem;
  width: 140px;
  align-items: center;
}
.previewbtn {
  margin: 0.5rem 0.55rem;
  padding: 0.375rem 2rem;
  border-radius: 1rem;
  align-items: center;
}
.table > :not(caption) > * > * {
  padding: 0rem 0.2rem;
}
thead {
  text-align: center;
  vertical-align: middle;
}
.thead-light {
  background-color: lightgray;
}
tbody {
  text-align: center;
  vertical-align: middle;
}
.label1 {
  margin-right: 60px;
}
.label2 {
  margin-right: 20px;
}
.label3 {
  margin-right: 10px;
}
.select1 {
  width: 280px;
  margin-right: 20px;
}
.text1 {
  margin-right: 60px;
}
.text2 {
  width: 240px;
}
.inputDate {
  margin-right: 20px;
}
.tableLabel {
  margin: 10px;
}
.unchanged {
  background-color: #fffdbf;
}
.form-check-input#rdoDefault {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-check-input#rdoAgsegment {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-check-input#rdoKobetuAg {
  margin-bottom: -0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.2rem;
  vertical-align: inherit;
}
.form-control {
  display: inline-block;
  vertical-align: middle;
}
.form-control#txtDispDtFrom {
  width: initial;
}
.form-control#reflectionDate {
  width: initial;
}
.form-control#txtSettingName {
  width: initial;
}
select.form-control {
  -webkit-appearance: auto;
  appearance: auto;
}
.form-control#table {
  padding: initial;
  padding-left: 5px;
  border-color: lightskyblue;
}
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
